const TEXT =
  "HVAC REPAIR & INSTALLATION • PRECISION PLUMBING • CUSTOM CARPENTRY & FRAMING • GENERAL HANDYMAN & CONTRACTING • EMERGENCY RESPONSE • LAWRENCEVILLE, IL • CALL +1 812-830-2316 • ";

export const Marquee = () => (
  <div className="bg-orange-600 text-[#0c0e12] py-3 overflow-hidden border-y border-orange-400/40" data-testid="services-marquee">
    <div className="flex whitespace-nowrap w-max animate-marquee">
      {[0, 1].map((i) => (
        <span
          key={i}
          aria-hidden={i === 1}
          className="font-mono text-sm font-bold tracking-[0.25em] uppercase"
        >
          {TEXT.repeat(2)}
        </span>
      ))}
    </div>
  </div>
);
